export default "__VITE_ASSET__BSl0TG98__";